module.exports = __webpack_public_path__ + "static/media/reef-dark-console-coral (1).20e5596d.png";